var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c("fieldset", { staticClass: "form__group" }, [
        _c("legend", [_vm._v("The Company")]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.companyName,
                expression: "formData.companyName",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "company",
              name: "company name",
              placeholder: "Enter company's name here...",
              required: "",
            },
            domProps: { value: _vm.formData.companyName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "companyName", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "company" } },
            [_vm._v("Client company name")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("company name"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.location,
                expression: "formData.location",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "location",
              name: "location",
              placeholder: "Enter the location of activities here...",
              required: "",
            },
            domProps: { value: _vm.formData.location },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "location", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "location" } },
            [_vm._v("Location of Activities")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("location"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.website,
                expression: "formData.website",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "website",
              name: "website",
              placeholder: "Enter company's website address here...",
              required: "",
            },
            domProps: { value: _vm.formData.website },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "website", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "website" } },
            [_vm._v("Website")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("website"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.description,
                expression: "formData.description",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "bio",
              name: "company bio",
              placeholder: "Enter the company bio here...",
              required: "",
            },
            domProps: { value: _vm.formData.description },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "description", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "form__label", attrs: { for: "bio" } }, [
            _vm._v("Company Bio"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("company bio"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.context,
                expression: "formData.context",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "context",
              name: "context",
              placeholder: "Enter the context here...",
              required: "",
            },
            domProps: { value: _vm.formData.context },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "context", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "context" } },
            [_vm._v("Context")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("context"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.buyerExamples,
                expression: "formData.buyerExamples",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "examples",
              name: "buyer examples",
              placeholder:
                "Enter the example buyers here, use a comma after each buyer example...",
              required: "",
            },
            domProps: { value: _vm.formData.buyerExamples },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "buyerExamples", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "examples" } },
            [_vm._v("Example buyers/targets")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("buyer examples"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: "submit",
                  expression: '"submit"',
                  arg: "disabled",
                },
              ],
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.back.apply(null, arguments)
                },
              },
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: "submit",
                  expression: '"submit"',
                  arg: "disabled",
                },
              ],
              staticClass: "btn btn--primary",
            },
            [_vm._v("Save & Continue")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }